import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Theme, Box, Link as MUILink, Divider } from '@material-ui/core'
import { useIntl } from 'react-intl'
import messages from '../../messages'
import {
  defaultEmail,
  defaultPhone,
} from '@src/routes/Configurators/utils/constants'
import * as HelpInfo from '@src/routes/Configurators/utils/HelpInfo.json'
import { useRouter } from '@src/routes'
import { useUserSession } from '@utils/useUserSession'
import ConfiguratorVideoTutorial from '@src/routes/Configurators/components/ConfiguratorVideoTutorial'

const useStyles = makeStyles((theme: Theme) => {
  return {
    helpText: {
      fontSize: theme.typography.pxToRem(14),
      cursor: 'pointer',
    },
    helpLink: {
      color: theme.palette.primary.main,
    },
    divider: {
      margin: `0px ${theme.spacing(2)}px`,
      width: 1,
      height: 20,
    },
    oldProduct: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(8),
      fontWeight: 700,
    },
    oldProductFont: {
      fontWeight: 700,
    },
  }
})

const HeaderHelpSection: React.FC<{ oldProduct?: boolean }> = ({
  oldProduct,
}) => {
  const classes = useStyles()
  const intl = useIntl()
  const router = useRouter()
  const { userSession } = useUserSession()
  let { product = '' } = router.query
  if (router.pathname === '/[country]/[language]/configurators/milliplex')
    product = 'milliplex'
  const country = userSession.country

  const email = () => {
    if (HelpInfo[`CONF_EMAIL_ADDRESS_${country}_${product}`]) {
      return HelpInfo[`CONF_EMAIL_ADDRESS_${country}_${product}`]
    } else {
      if (HelpInfo[`CONF_EMAIL_ADDRESS_${country}_default`]) {
        return HelpInfo[`CONF_EMAIL_ADDRESS_${country}_default`]
      } else {
        return defaultEmail
      }
    }
  }
  const phoneNumber = () => {
    if (HelpInfo[`CONF_TEL_${country}_${product}`]) {
      return HelpInfo[`CONF_TEL_${country}_${product}`]
    } else {
      if (HelpInfo[`CONF_TEL_${country}_default`]) {
        return HelpInfo[`CONF_TEL_${country}_default`]
      }
      return defaultPhone
    }
  }

  const options = [
    {
      label: oldProduct
        ? email()
        : intl.formatMessage(messages.CUSTOMER_SERVICE),
      url: `mailto:${email()}`,
    },
    {
      label: phoneNumber(),
      url: oldProduct ? `callto:${phoneNumber()}` : null,
    },
  ]

  return (
    <Box display="flex" className={oldProduct ? classes.oldProduct : undefined}>
      <ConfiguratorVideoTutorial
        className={oldProduct ? classes.oldProductFont : undefined}
      />
      {options.map((item, index) => {
        return (
          <React.Fragment key={index}>
            {item.url ? (
              <MUILink
                href={item.url}
                className={oldProduct ? classes.oldProductFont : undefined}
              >
                {item.label}
              </MUILink>
            ) : (
              <MUILink
                color="primary"
                className={oldProduct ? classes.oldProductFont : undefined}
              >
                {item.label}
              </MUILink>
            )}
            {options.length - 1 > index ? (
              <Divider className={classes.divider} />
            ) : null}
          </React.Fragment>
        )
      })}
    </Box>
  )
}

export default HeaderHelpSection
